"use strict";

exports.__esModule = true;
exports.default = exports.ConnectedWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _index = _interopRequireDefault(require("./sagas/index"));

var _index2 = _interopRequireDefault(require("./reducers/index"));

var _TranslationContext = require("./context/TranslationContext");

var _App = _interopRequireDefault(require("./components/App"));

var _PropsContext = require("./context/PropsContext");

var _excluded = ["i18n", "language", "__instanceId", "__pageId"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Widget = function Widget(_ref) {
  var i18n = _ref.i18n,
      language = _ref.language,
      __instanceId = _ref.__instanceId,
      __pageId = _ref.__pageId,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var t = i18n ? function (key, options) {
    var tr = i18n(key, options);
    return tr || key;
  } : function (key) {
    return key;
  };
  if (!language) return null;
  return /*#__PURE__*/_react.default.createElement(_TranslationContext.TranslationProvider, {
    t: t
  }, /*#__PURE__*/_react.default.createElement(_PropsContext.PropsProvider, {
    widgetProps: {
      __instanceId: __instanceId,
      __pageId: __pageId,
      language: language
    }
  }, /*#__PURE__*/_react.default.createElement(_App.default, _extends({
    instanceId: __instanceId,
    pageId: __pageId
  }, props))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    language: state.language.language
  };
};

var ConnectedWidget = (0, _reactRedux.connect)(mapStateToProps)(Widget);
exports.ConnectedWidget = ConnectedWidget;
var exported = ConnectedWidget;
Widget.propTypes = {
  i18n: _propTypes.default.any,
  language: _propTypes.default.string,
  __instanceId: _propTypes.default.string,
  __pageId: _propTypes.default.string
};
exported.reducer = _index2.default;
exported.sagas = _index.default;
var _default = exported; // exported.middlewares = [logger];

exports.default = _default;